import { Component, Input } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "../../../../interfaces/app-state.interface";
import { AdvisorEntity } from "../../../../entities/advisor.entity";
import { ActionEventsEnum } from "../.../../../../../enum/tracking/action-events.enum";

@Component({
    selector: 'tr-advisor-buttons',
    templateUrl: './advisor-buttons.component.html',
    styleUrls: ['./advisor-buttons.component.scss'],
})
export class AdvisorButtonsComponent {
    @Input() public advisor: AdvisorEntity;

    constructor(
        private store: Store<AppState>
    ) { }

    public handleWhatsappButton() {
        this.store.dispatch(
            this.advisor.getAnalyticsEvent(
                ActionEventsEnum.USER_CLICKED,
                '[Botão] Entrar em contato pelo WhatsApp',
            )
        );
    }

    public handleScheduleButton() {
        this.store.dispatch(
            this.advisor.getAnalyticsEvent(
                ActionEventsEnum.USER_CLICKED,
                '[Botão] Agendar reunião'
            )
        );
    }
}